import { render } from "./ValueListItem.vue?vue&type=template&id=47974c88"
import script from "./ValueListItem.vue?vue&type=script&lang=js"
export * from "./ValueListItem.vue?vue&type=script&lang=js"

import "./ValueListItem.vue?vue&type=style&index=0&id=47974c88&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.19.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__